/**
 * Notification form-effect — exposes email notification and auto-responder
 * configuration via body attributes so the submit handler can read them.
 * All actual email sending happens server-side.
 * SSR-safe: returns undefined if document is not available.
 */

import type { FormEffectHandler } from '@atlas-forms/types-js';
import { str } from './utils';

export const notificationEffect: FormEffectHandler = (config) => {
  if (typeof document === 'undefined') return;

  // Auto-responder enabled flag
  if (config.autoResponderEnabled === true) {
    document.body.setAttribute('data-atlas-auto-responder', 'true');
  }

  // Auto-responder email field name
  const autoResponderEmailField = str(config.autoResponderEmailField);
  if (autoResponderEmailField) {
    document.body.setAttribute('data-atlas-auto-responder-field', autoResponderEmailField);
  }

  // Auto-responder subject
  const autoResponderSubject = str(config.autoResponderSubject);
  if (autoResponderSubject) {
    document.body.setAttribute('data-atlas-auto-responder-subject', autoResponderSubject);
  }

  // Notification subject
  const notificationSubject = str(config.notificationSubject);
  if (notificationSubject) {
    document.body.setAttribute('data-atlas-notification-subject', notificationSubject);
  }

  return () => {
    document.body.removeAttribute('data-atlas-auto-responder');
    document.body.removeAttribute('data-atlas-auto-responder-field');
    document.body.removeAttribute('data-atlas-auto-responder-subject');
    document.body.removeAttribute('data-atlas-notification-subject');
  };
};
